export default () => {
  const accordionElements = document.querySelectorAll('[component="navigation-hotel-accordion"]');

  accordionElements.forEach((accordion) => {
    const toggleButton = accordion.querySelector('[child="head"]');
    const contentSection = accordion.querySelector('[child="body"]');

    if (toggleButton && contentSection) {
      toggleButton.addEventListener('click', () => {
        const isOpen = toggleButton.getAttribute('data-is-open');

        if (isOpen === 'true') {
          contentSection.style.height = '0px';
          toggleButton.setAttribute('data-is-open', 'false');
        } else {
          contentSection.style.height = 'auto';

          toggleButton.setAttribute('data-is-open', 'true');
        }
      });
    }
  });
};
